module.exports = __webpack_public_path__ + "static/media/mangrove-alliance.4ce96ed1.png";